export default "__VITE_ASSET__DCuaIzrM__"